import { parseAccountBalance, resolveMinimumLaunchBalance } from './businessBalance';

/**
 * Utility function to determine the color for account balance display
 * @param {string} balance - The account balance string (e.g., "$25.50")
 * @param {object} business - Business state containing backend payment rules
 * @returns {string} - The color to use for the balance display
 */
export const getBalanceColor = (balance, business) => {
  try {
    const balanceAmount = parseAccountBalance(balance);
    const minimum = resolveMinimumLaunchBalance(business);

    if (minimum === null || balanceAmount < minimum) {
      return 'error.main';
    }
    if (balanceAmount < 50) {
      return 'warning.main';
    }
    return 'success.main';
  } catch (error) {
    return 'error.main';
  }
};

/**
 * Utility function to get the balance display text with appropriate color
 * @param {string} balance - The account balance string
 * @param {string} prefix - The prefix text (default: "Account balance:")
 * @returns {object} - Object containing text and color
 */
export const getBalanceDisplay = (balance, prefix = "Account balance:", business) => {
  const color = getBalanceColor(balance, business);
  
  return {
    text: `${prefix} ${balance}`,
    color: color
  };
};
